import { apiUrlPrefix } from "./settings";
import ReactDOM from 'react-dom';
import { format } from "date-fns";
import ScrapingTool from "./components/Scraping/ScrapingTool";
import DirectoriesIndex from "./components/directories/directoriesIndex";
import React, { useState, useEffect } from 'react';
import DataLoader from "./components/DataLoading/DataLoader";
import QuarterRun from "./components/Mechanical/quarterRun";
import Reports from "./components/Reports/Reports";
import AssetCompareIndex from './components/MetaData/AssetPortal/AssetCompareIndex'
import cachingMechanisum from "./components/Common/cachingMechanisum";
import { createRoot, Root } from 'react-dom/client';

export class CommonUtilities {

    static monthShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    static monthFull = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    static removeLastCharacter(input: any) {
        var CharLength = input?.length;
        return input.slice(0, (CharLength - 1));
    }

    static BtnLoading = (idName: any) => {
        //const value = document.querySelector('[id^="'+ idName+'"]');
        //value?.classList.add("loading");
        //this.blockUiLoading(true);
    }

    static RemoveBtnLoading = (idName: any) => {
        //const value = document.querySelector('[id^="'+ idName+'"]');         
        //value?.classList.remove('loading');
        //this.blockUiLoading(false);         
    }

    static mapQueryParams(queryParams: string) {
        return queryParams
            ? Object.keys(queryParams).map(function (key) {
                return key;// + '=' + queryParams[key]
            }).join('&')
            : ""
    }

    static getAuthAccess() {
        const empty = { email: '', userId: '' };
        const raw = window.sessionStorage.getItem('loggedUserRight');

        if (!raw) return empty;

        try {
            return JSON.parse(raw);
        } catch (error) {
            console.error('loggedUserRight in sessionStorage is corrupted or truncated', error);
            window.sessionStorage.removeItem('loggedUserRight');
            this.clearAuthToken(); // optional: forces a fresh login so the value is rewritten
            return empty;
        }
    }

    static getAuthToken() {
        var authToken = '';

        if (window.sessionStorage.getItem('loggedUserRight')) {
            authToken = JSON.parse(window.sessionStorage.getItem('loggedUserRight') as string).token;
        }
        return authToken;

        if (authToken) {
            return authToken;
        } else {
            this.clearAuthToken();
        }

    }

    static setAuthToken(userDetails: any) {

        if (!JSON.stringify(userDetails)) {
            this.clearAuthToken();
        } else {

            /* var system = {
                 entityName: "System",
                 entityType: 1,
                 subEntities:
                     [{
                         entityType: 1,
                         isActive: 1,
                         subEntity: "Home",
                         subEntityCode: "home",
                         subEntityID: 1,
                         subEntityRef: 1
                     },  {
                         entityType: 1,
                         isActive: 1,
                         subEntity: "Reports",
                         subEntityCode: "Grid_Reporting",
                         subEntityID: 1,
                         subEntityRef: 1
                     }, {
                         entityType: 1,
                         isActive: 1,
                         subEntity: "Uploader",
                         subEntityCode: "download",
                         subEntityID: 1,
                         subEntityRef: 1
                     }/*, {
                         entityType: 8,
                         isActive: 1,
                         subEntity: "Affiliate",
                         subEntityCode: "Affiliate",
                         subEntityID: 18,
                         subEntityRef: 2622144
                     },{
                         entityType: 1,
                         isActive: 1,
                         subEntity: "Directories",
                         subEntityCode: "Portal_Directories",
                         subEntityID: 1,
                         subEntityRef: 1
                     }]
             };*/

            var temp = userDetails.userEntityRight;
            userDetails.userEntityRight = [];
            //userDetails.userEntityRight.push(system);
            userDetails.userEntityRight.push(...temp);

            //const [names, setNames] = useState(['Alice', 'Bob']);
            //setNames(current => [...current, ...arr]);

            window.sessionStorage.setItem('loggedUserRight', JSON.stringify(userDetails));
            window.sessionStorage.setItem('loggedInUser', JSON.stringify(userDetails));

            window.location.reload();
        }
    }

    static clearAuthToken() {
        window.sessionStorage.removeItem('loggedUserRight');
        window.sessionStorage.removeItem('loggedInUser');
        window.location.reload();
    }

    static async dataPassingHandler(data: any) {
        this.blockUiLoading(false);

        if (data && typeof data.json === 'function') {
            const contentType = data.headers.get('content-type');

            // console.log(contentType)
            // Check if the response is actually JSON
            if (contentType && contentType.includes('application/json')) {

                return data.json(); // Parse JSON
            } else {
                return data.text();; // You can choose to return this, or wrap it in an object
            }
        }
    }

    static async getData(url: string) {
        try {
            CommonUtilities.APILoadingToast('Loading', 'fail')
            let fullUrl = `${apiUrlPrefix.replace(/\/$/, '')}/${url.replace(/^\/+/, '')}`;

            let response = await fetch(fullUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-AuthToken': this.getAuthToken()
                }
            })
            const errorGot = await this.dataPassingHandler(await response);;

            if (!response.ok) {
                CommonUtilities.CancelAPILoadingToast();
                if (response?.status === 401) {
                    this.clearAuthToken();
                } else {
                    CommonUtilities.showToastDawer(errorGot?.Message, 'fail');
                    return errorGot;
                }
            } else
                CommonUtilities.CancelAPILoadingToast();

            return (errorGot);

        } catch (error) {
            //this.blockUiLoading(false);

            CommonUtilities.CancelAPILoadingToast();
            console.log('error Api get');
            this.clearAuthToken();

            const err = error as Error;
            console.error('API POST error:', err);
            alert(`An error occurred: ${err.message}`);
            return null;
        }
    }

    static async getDataThirdParty(url: string, data: any) {

        url = url + data;
        //console.log(url);

        try {

            this.blockUiLoading(true);

            let response = fetch(url, {
                headers: {
                    //"Access-Control-Allow-Origins": "*",
                    //"Access-Control-Allow-Headers": "Content-Type",
                    //"Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-AuthToken': this.getAuthToken()
                }
            })

            response.then(status => {
                // console.log(status.status);
                //console.log(status);
                if (status.status && status.status === 401) {
                    //this.clearAuthToken();
                }
            });
            //console.log(response)

            return (this.dataPassingHandler(await response));


        } catch (error) {
            this.blockUiLoading(false);
            console.log('error Api get');
            //this.clearAuthToken();
            return null;
        }
    }

    static loadingCounter: number = 0;
    static blockUiLoading(startStop: boolean) {
        const container = document.getElementById('block-ui-container');
        if (!container) return;

        if (startStop) {
            this.loadingCounter++;
        } else {
            this.loadingCounter = Math.max(0, this.loadingCounter - 1);
        }

        var element = (<div></div>);

        if (this.loadingCounter > 0) {
            element = (
                <div>
                    <div className="loader">
                        <div className="bar1"></div>
                        <div className="bar2"></div>
                        <div className="bar3"></div>
                        <div className="bar4"></div>
                        <div className="bar5"></div>
                        <div className="bar6"></div>
                    </div>
                    <div id="block-ui-message-container">
                        &nbsp;
                    </div>
                </div>
            );
        }
        //ReactDOM.render(element, document.getElementById('block-ui-container'));
    }

    static reMap = (mapReturn: any) => {
        var tempmapReturn: any[] = [];
        Object.entries(mapReturn).forEach(([key, value]) => { tempmapReturn.push(value) });
        return tempmapReturn;
    }

    static async postData(url: string, params: any) {
        try {
            CommonUtilities.APILoadingToast('Loading', 'fail')
            this.blockUiLoading(true);
            let response = await fetch(apiUrlPrefix + url, {
                method: "POST",
                body: JSON.stringify(params),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-AuthToken': this.getAuthToken()
                }
            })

            //console.log(response);
            const errorGot = await this.dataPassingHandler(await response);;
            if (!response.ok) {
                CommonUtilities.CancelAPILoadingToast();

                if (response?.status === 401) {
                    this.clearAuthToken();
                } else {
                    CommonUtilities.showToastDawer(errorGot?.Message, 'fail');
                    return errorGot;
                }
            } else
                CommonUtilities.CancelAPILoadingToast();

            return (errorGot);

        } catch (error) {

            CommonUtilities.CancelAPILoadingToast();
            this.blockUiLoading(false);

            console.log('error Api get');
            this.clearAuthToken();

            const err = error as Error;
            console.error('API POST error:', err);
            alert(`An error occurred: ${err.message}`);

            return null;
        }
    }

    static showToast(errorMessage: any) {
        const container = document.getElementById('block-ui-container');

        console.log("container")
        console.log(container)

        if (!container) return;
        this.loadingCounter = Math.max(0, this.loadingCounter - 1);

        var element = (<div></div>);
        element = (
            <div id="apiError" style={{
                position: "fixed",
                top: "20px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "#e53935", // beautiful red
                color: "white",
                padding: "16px 24px",
                borderRadius: 8,
                boxShadow: "0 4px 12px rgba(229, 57, 53, 0.7)",
                fontWeight: "600",
                fontSize: 16,
                transition: "opacity 0.5s ease-in-out",
                zIndex: 9999,
                pointerEvents: "auto",
                maxWidth: "90vw",
                textAlign: "center",
            }}>
                <span style={{ flex: 1 }}>{errorMessage}</span>

                <button onClick={this.handleClose}
                    aria-label="Close error message"
                    style={{
                        background: "transparent",
                        border: "none",
                        color: "white",
                        fontSize: 20,
                        fontWeight: "bold",
                        cursor: "pointer",
                        lineHeight: 1,
                        padding: 0,
                        marginLeft: 12,
                        userSelect: "none",
                    }}
                >  ×  </button>

            </div>
        );

        const containerExist = document.getElementById('apiError');

        if (containerExist) {
            containerExist.removeAttribute('style');
            Object.assign(containerExist.style, {
                position: "fixed",
                top: "20px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "#e53935",
                color: "white",
                padding: "16px 24px",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(229, 57, 53, 0.7)",
                fontWeight: "600",
                fontSize: "16px",
                transition: "opacity 0.5s ease-in-out",
                zIndex: "9999",
                pointerEvents: "auto",
                maxWidth: "90vw",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            });

            // 3️⃣ Update content if needed
            const span = containerExist.querySelector('span');
            if (span) span.textContent = errorMessage;
        } else {
            //ReactDOM.render(element, document.getElementById('block-ui-container'));
        }

        const container_Exist = document.getElementById('apiError');
        if (container_Exist) {
            setTimeout(() => container_Exist.style.display = 'none', 3000);
        }

    }

    static showToastDawer(errorMessage: string, type: any) {
        let container = document.getElementById('apiError');
        const toastRootMap = new Map<Element, Root>();
        let color = '#61d820ff';

        if (type === 'fail') {
            color = '#e53935';
        }

        if (type === 'Success') {
            color = '#61d820ff';
        }

        if (!container) {
            container = document.createElement('div');
            container.id = 'apiError';
            document.body.appendChild(container);
        }

        let root = toastRootMap.get(container);

        if (!root) {
            root = createRoot(container);
            toastRootMap.set(container, root);
        }

        const closeToast = () => {
            root?.unmount();
            toastRootMap.delete(container!);
            container?.remove();
        };

        root.render(
            <div style={{
                position: "fixed",
                top: "20px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: color,
                color: "white",
                padding: "16px 24px",
                borderRadius: 8,
                boxShadow: "0 4px 12px " + color,
                fontWeight: 600,
                fontSize: 16,
                zIndex: 20000,
                display: "flex",
                alignItems: "center",
                gap: 12,
                maxWidth: "90vw",
            }}>
                <span>{errorMessage}</span>

                <button
                    onClick={closeToast}
                    style={{
                        background: "transparent",
                        border: "none",
                        color: "white",
                        fontSize: 20,
                        cursor: "pointer",
                    }}
                >
                    ×
                </button>
            </div>
        );

        setTimeout(() => {
            closeToast();
        }, 3000);
    }

    static APILoadingToast(errorMessage: string, type: any) {

        const toastRootMap = new Map<Element, Root>();
        let container = document.getElementById('APILoadingToast');

        if (!container) {
            container = document.createElement('div');
            container.id = 'APILoadingToast';
            document.body.appendChild(container);
        }

        let root = toastRootMap.get(container);

        if (!root) {
            root = createRoot(container);
            toastRootMap.set(container, root);
        }

        root.render(
            <div style={{
                position: "fixed",
                top: "40px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "#4b5563",
                color: "white",
                padding: "16px 24px",
                borderRadius: 8,
                fontWeight: 600,
                boxShadow: "0 4px 12px #4b5563",
                fontSize: 16,
                zIndex: 20000,
                display: "flex",
                alignItems: "center",
                maxWidth: "440px",
                minWidth: "320px",
                flexDirection: "column",
                gap: 12,
                animation: "fadeSlide 0.3s ease-out",
            }}>
                <div className="ws-12 white">
                    <div className="ws-9">
                        <span className="ws-12 text-bold text-l white">
                            {errorMessage}
                        </span>

                        <span className="ws-12 white mt">
                            This may take a few seconds....
                        </span>
                    </div>

                    <div className="loaderNew pull-right"></div>
                </div>
            </div>
        );
    }

    static CancelAPILoadingToast() {
        const container = document.getElementById('APILoadingToast');

        if (container) {
            (ReactDOM as any).unmountComponentAtNode(container);
            container.remove();
        }
    }

    static showToastSuccess(errorMessage: any) {
        const container = document.getElementById('block-ui-container');

        console.log("container")
        console.log(container)
        if (!container) return;
        this.loadingCounter = Math.max(0, this.loadingCounter - 1);

        var element = (<div></div>);
        element = (
            <div id="apiError" style={{
                position: "fixed",
                top: "20px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "#61d820ff", // beautiful red
                color: "white",
                padding: "16px 24px",
                borderRadius: 8,
                boxShadow: "0 4px 12px rgba(26, 202, 14, 0.7)",
                fontWeight: "600",
                fontSize: 16,
                transition: "opacity 0.5s ease-in-out",
                zIndex: 9999,
                pointerEvents: "auto",
                maxWidth: "90vw",
                textAlign: "center",
            }}>
                <span style={{ flex: 1 }}>{errorMessage}</span>

                <button onClick={this.handleClose}
                    aria-label="Close error message"
                    style={{
                        background: "transparent",
                        border: "none",
                        color: "white",
                        fontSize: 20,
                        fontWeight: "bold",
                        cursor: "pointer",
                        lineHeight: 1,
                        padding: 0,
                        marginLeft: 12,
                        userSelect: "none",
                    }}
                >  ×  </button>

            </div>
        );

        const containerExist = document.getElementById('apiError');

        if (containerExist) {
            containerExist.removeAttribute('style');
            Object.assign(containerExist.style, {
                position: "fixed",
                top: "20px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "#61d820ff",
                color: "white",
                padding: "16px 24px",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(26, 202, 14, 0.7)",
                fontWeight: "600",
                fontSize: "16px",
                transition: "opacity 0.5s ease-in-out",
                zIndex: "9999",
                pointerEvents: "auto",
                maxWidth: "90vw",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            });

            const span = containerExist.querySelector('span');
            if (span) span.textContent = errorMessage;
        } else {
            //ReactDOM.render(element, document.getElementById('block-ui-container'));
        }

        const container_Exist = document.getElementById('apiError');
        if (container_Exist) {
            setTimeout(() => container_Exist.style.display = 'none', 3000);
        }
    }

    static handleClose = (e: any) => {

        const container = document.getElementById('apiError');
        if (container) {
            container.style.display = 'none';
        }
    }

    static exportToCSV(data: any[], fileName: string = 'export.csv') {
        if (!data || !data.length) return;

        const headers = Array.from(new Set(data.flatMap(item => Object.keys(item))));

        const csvRows = [
            headers.join(','), // header row
            ...data.map(row =>
                headers
                    .map(header => {
                        const value = row[header] ?? ''; // handle undefined/null
                        return `"${String(value).replace(/"/g, '""')}"`; // escape quotes
                    })
                    .join(',')
            ),
        ];

        const csvContent = csvRows.join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    static exportToCSVNoHeader(array1: any[], array2: any[], fileName: string = 'export.csv') {
        const row1 = array1.map(val => `"${val}"`).join(',');
        const row2 = array2.map(val => `"${val}"`).join(',');

        // Combine into CSV (each array is a separate row)
        const csvContent = `${row1}\n${row2}`;

        // Trigger download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    /*
    exportToCSV_Header
    array 1 is 1st top header
    array 2 is 2nd top header
    array 3 is data  where data = [ [] , [] , [] ,]
    */
    static exportToCSV_Header(array1: any[], array2: any[], array3: any[][], fileName: string = 'export.csv') {
        let row1 = "";
        if (array1.length > 0) {
            row1 = array1.map(val => `"${val}"`).join(',');
        }

        let row2 = "";
        if (array2.length > 0) {
            row2 = array2.map(val => `"${val}"`).join(',')
        }

        // Convert array3 (2D) to CSV rows
        const rows3 = array3.map(row => row.map(val => `"${val}"`).join(',')).join('\n');

        // Combine everything
        const csvContent = [row1, row2, rows3].filter(Boolean).join('\n');

        // Trigger download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    static async postUploadFile(url: string, file: any, data: any) {
        this.blockUiLoading(true);
        //console.log(data);
        var imgdata = new FormData();
        imgdata.append("file", file)
        imgdata.append("data", JSON.stringify(data));

        CommonUtilities.APILoadingToast('Loading', 'fail')

        try {
            let response = await fetch(apiUrlPrefix + url, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'X-AuthToken': this.getAuthToken()
                },
                body: imgdata
            })
            let jsonResponse = await response.json();
            this.blockUiLoading(false);
            CommonUtilities.CancelAPILoadingToast();
            return jsonResponse;
        } catch (error) {
            this.blockUiLoading(false);

            const err = error as Error;

            CommonUtilities.showToastDawer(err?.toString(), 'fail');
            console.error('API POST error:', err);
            alert(`An error occurred: ${err.message}`);

            this.clearAuthToken();
            return null;
        }

    }

    static async postUploadFileClientProfile(url: string, file: any) {
        this.blockUiLoading(true);

        var imgdata = new FormData();
        imgdata.append("file", file);

        try {
            let response = await fetch(apiUrlPrefix + url, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'X-AuthToken': this.getAuthToken()
                },
                body: imgdata
            });

            let jsonResponse = await response.json();
            this.blockUiLoading(false);
            return jsonResponse;
        } catch (error) {
            this.blockUiLoading(false);
            this.clearAuthToken();

            const err = error as Error;
            console.error('API POST error:', err);
            alert(`An error occurred: ${err.message}`);
            return null;
        }
    }

    static async putData(url: string, body: FormData) {
        this.blockUiLoading(true);
        try {
            let response = await fetch(apiUrlPrefix + url, {
                method: "PUT",
                body: JSON.stringify(body),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-AuthToken': this.getAuthToken()
                }
            })
            let jsonResponse = await response.json();
            this.blockUiLoading(false);
            return jsonResponse;
        } catch (error) {
            this.blockUiLoading(false);
            this.clearAuthToken();

            const err = error as Error;
            console.error('API POST error:', err);
            alert(`An error occurred: ${err.message}`);
            return null;
        }
    }

    static async deleteData(url: string) {
        this.blockUiLoading(true);
        try {
            let response = await fetch(apiUrlPrefix + url, {
                method: "DELETE",
                /// body: JSON.stringify(url),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-AuthToken': this.getAuthToken()
                }
            })
            let jsonResponse = await response.json();
            this.blockUiLoading(false);
            return jsonResponse;
        } catch (error) {
            this.blockUiLoading(false);
            this.clearAuthToken();
            const err = error as Error;
            console.error('API POST error:', err);
            alert(`An error occurred: ${err.message}`);
            return null;
        }
    }

    static weekNumber(dt: any) {
        const tdt: any = new Date(dt);
        const dayn = (dt.getDay() + 6) % 7;
        tdt.setDate(tdt.getDate() - dayn + 3);
        const firstThursday = tdt.getTime();
        tdt.setMonth(0, 1);
        if (tdt.getDay() !== 4) {
            tdt.setMonth(0, 1 + ((4 - tdt.getDay()) + 7) % 7);
        }
        return 1 + Math.ceil((firstThursday - tdt) / 604800000);
    }

    static objectSortingAsc = (objSort: any, fieldSorting: any) => {
        return [...objSort].sort((a, b) => b.fieldSorting - a.fieldSorting);
    }

    static lookUpTypeList(lookUpType: string, itemName: any, itemReference: string) {

        var tagColorListCache = cachingMechanisum?.getCachingStorage("tagColor");
        //console.log(tagColorListCache)

        if (lookUpType && itemName && tagColorListCache) {
            var temp = tagColorListCache?.filter((lookUpListItem: any) => lookUpListItem?.lookUpType?.toLocaleLowerCase() === lookUpType.toLocaleLowerCase() && lookUpListItem.itemName.toLocaleLowerCase() === itemName.toLocaleLowerCase());
        } else if (lookUpType && tagColorListCache) {
            var temp = tagColorListCache?.filter((lookUpListItem: any) => lookUpListItem?.lookUpType?.toLocaleLowerCase() === lookUpType.toLocaleLowerCase());
            return temp;
        } else if (tagColorListCache) {
            var temp = tagColorListCache?.filter((lookUpListItem: any) => lookUpListItem.lookUpType === "General");
        }

        if (temp && temp.length === 0) {
            var temp = tagColorListCache?.filter((lookUpListItem: any) => lookUpListItem.lookUpType === "General");
        }

        if (itemReference === 'fontColor' && temp && temp.length > 0) {
            return (temp[0].fontColor)?.toString();

        } else if (itemReference === 'bgColor' && temp && temp.length > 0) {
            return (temp[0].bgColor)?.toString();
        } else {
            return '';
        }

    }

    static lookUpTypeListByKey(lookUpType: string, key: string, itemReference: string) {
        var lookUpTypeList = cachingMechanisum.getCachingStorage("lookUpType");
        if (lookUpType && itemReference) {
            var temp = lookUpTypeList?.filter((lookUpListItem: any) => lookUpListItem?.lookUpType?.toLocaleLowerCase() === lookUpType.toLocaleLowerCase() && lookUpListItem.key.toLocaleLowerCase() === key.toLocaleLowerCase());
        } else {
            var temp = lookUpTypeList;
        }
        //console.log(temp)
        if (itemReference === 'value' && temp && temp.length > 0) {
            return (temp[0].value)?.toString();

        } else {
            return '';
        }

    }

    static iconUrlAssignment(subEntityName: string) {
        const landingPage = [
            {
                subEntityName: 'Home',
                subEntityURL: '../../'
            }, {
                subEntityName: 'file2',
                subEntityURL: '../../apps/index.html'
            }, {
                subEntityName: 'pie-chart',
                subEntityURL: '../../apps/contracts/#/summary/'
            }, {
                subEntityName: 'Management',
                subEntityURL: '../../apps/dataMGT/#/itunesMonthly'
            }, {
                subEntityName: 'Matching',
                subEntityURL: '../../apps/dataMGT/#/matching'
            }, {
                subEntityName: 'Management',
                subEntityURL: '../../apps/dataMGT/#/matching'
            }, {
                subEntityName: 'Analytics',
                subEntityURL: '../../apps/affiliates/'
            }, {
                subEntityName: 'Custom Splice',
                subEntityURL: '../../apps/affiliate/'
            }, {
                subEntityName: 'TrackSplit',
                subEntityURL: '../../apps/metadata/#/trackSplit'
            }, {
                subEntityName: 'Portal_TrackSplit',
                subEntityURL: '../../apps/metadata/#/trackSplit'
            }, {
                subEntityName: 'Transaction',
                subEntityURL: '../../apps/dataMGT/#/salesAnalysis'
            }, {
                subEntityName: 'contacts',
                subEntityURL: '../../apps/userManagement/#/register'
            }, {
                subEntityName: 'Licensing',
                subEntityURL: '../../apps/licensing/'
            }, {
                subEntityName: 'Payments',
                subEntityURL: '../../apps/transaction/#/suggestedPayment'
            }, {
                subEntityName: 'stats',
                subEntityURL: '../../apps/transaction/#/quarterRun'
            }, {
                subEntityName: 'calendar5',
                subEntityURL: '../../apps/systemSettings/#/periodMGT'
            }, {
                subEntityName: 'settings1',
                subEntityURL: '../../apps/systemSettings/#/controlPanel'
            }, {
                subEntityName: 'user2',
                subEntityURL: '../../apps/systemSettings/#/clientProfile'
            }, {
                subEntityName: 'line-chart',
                subEntityURL: '../../apps/systemSettings/#/auditTrail'
            }, {
                subEntityName: 'Contracts',
                subEntityURL: '../../apps/contracts/#/'
            }, {
                subEntityName: 'Contacts',
                subEntityURL: '../../apps/contacts/#/'
            }, {
                subEntityName: 'Grid_Approval',
                subEntityURL: '../../apps/statements/'
            }, {
                subEntityName: 'Reports',
                subEntityURL: '../../apps/reportings/'
            }, {
                subEntityName: 'Project',
                subEntityURL: '../../apps/licensingPortal/#/projectGrid'
            }, {
                subEntityName: 'Pitch',
                subEntityURL: '../../apps/licensingPortal/#/pitchGrid'
            }, {
                subEntityName: 'tasks',
                subEntityURL: '../../apps/licensingPortal/#/bulkGrid'
            }, {
                subEntityName: 'Uploader',
                subEntityURL: '../Uploader'
            }, {
                subEntityName: 'stack2',
                subEntityURL: '../../apps/systemListings/#/'
            }, {
                subEntityName: 'Publishing_Project',
                subEntityURL: '../../apps/contracts/'
            }, {
                subEntityName: 'Synch_Project',
                subEntityURL: '../../apps/licensingPortal/#/projectGrid?Synch'
            }, {
                subEntityName: 'Mechanical_Project',
                subEntityURL: '../../apps/contracts/'
            }, {
                subEntityName: 'Mechanicals',
                subEntityURL: '../../apps/transaction/#/quarterRun'
            }, {
                subEntityName: 'Transaction',
                subEntityURL: '../../apps/dataMGT/#/salesAnalysis/digital'
            }, {
                subEntityName: 'Publishing_Transaction',
                subEntityURL: '../../apps/dataMGT/#/salesAnalysis/publishingSong'
            }, {
                subEntityName: 'Other_Transaction',
                subEntityURL: '../../apps/dataMGT/#/salesAnalysis/costs'
            }, {
                subEntityName: 'Track',
                subEntityURL: '../../apps/metadata/#/tracks'
            }, {
                subEntityName: 'Release',
                subEntityURL: '../../apps/metadata/#/'
            }, {
                subEntityName: 'Song',
                subEntityURL: '../../apps/metadata/#/songs'
            }, {
                subEntityName: 'Assets',
                subEntityURL: '../../apps/metadata/#/assets'
            }, {
                subEntityName: 'SongRegistration',
                subEntityURL: '../../apps/metadata/#/songRegistration?type=songBasket'
            }, {
                subEntityName: 'Projects',
                subEntityURL: '../../apps/contracts/#/projectContracts'
            }, {
                subEntityName: 'Recorded_Music',
                subEntityURL: '../../apps/contracts/'
            }, {
                subEntityName: 'Directories',
                subEntityURL: '../../apps/directories/#/creators'
            }

        ];

        for (var i = 0; i < landingPage.length; i++) {
            if (landingPage[i].subEntityName === subEntityName) {
                return landingPage[i].subEntityURL;
            }
        }
    }

    static portalSelection(portalSelection: any) {

        console.log(portalSelection);

        if (portalSelection.subEntity.subEntity === "Scraping Tool") {
            return (
                <ScrapingTool subEntity={portalSelection} />
            )
        }
        else if (portalSelection.subEntity.subEntity === "Directories" || portalSelection.subEntity === "Directories") {

            if (window.location.pathname === '/directories/') {
                return (
                    <DirectoriesIndex subEntity={portalSelection} pathname={window.location.pathname} />
                )
            } else {
                return (
                    <DirectoriesIndex subEntity={portalSelection} />
                )
            }
        }

        else if (portalSelection.subEntity.subEntity === "Asset Compare") {
            return (
                <AssetCompareIndex subEntity={portalSelection} />
            )
        }

        else if (portalSelection.subEntity.subEntity === "TrackSplit") {
            return (
                <ScrapingTool subEntity={portalSelection} />
            )
        }

        else if (portalSelection.subEntity.subEntity === "Uploader") {

            if (window.location.pathname === '/Uploader/') {
                return (
                    <DataLoader subEntity={portalSelection} />
                )
            } else {
                return (
                    <DataLoader subEntity={portalSelection} />
                )
            }
        }

        else if (portalSelection.subEntity.subEntity === "Mechanicals") {
            return (
                <QuarterRun subEntity={portalSelection} />
            )
        }

        else if (portalSelection.subEntity.subEntity === "Reports") {
            return (
                <Reports subEntity={portalSelection} />
            )
        }

        return false;
    }

    static longCharacter(character: any, length: any) {
        var newCharacter = '';
        //console.log(character.toString())
        if ((character) && (character.toString().length > length)) {
            newCharacter = character.toString().slice(0, length) + '...';
        }

        if ((character) && (character.toString().length <= length)) {
            newCharacter = character.toString();
        }

        return newCharacter;
    }
    static stringToArray(stringToArray: string, delimeter: string) {
        if (stringToArray) {
            return stringToArray.split(delimeter);
        } else {
            return [];
        }
    }

    static numberFormat(number: any, decimalPlace: number) {
        if (!number) {
            number = 0;
        }

        number = (Math.round(Number(number) * 100) / 100)?.toFixed(decimalPlace);

        if (number === 0.00) {
            return number;
        } else {
            number = (Math.round(Number(Math.abs(number)) * 100) / 100)?.toFixed(decimalPlace);
            return number;
        }

    }

    static parseStyleString(styleString: string) {
        const styleObject: { [key: string]: string } = {};
        const styleArray = styleString?.split(';')?.filter(Boolean);

        styleArray?.forEach((style) => {
            const [key, value] = style?.split(':')?.map((s) => s.trim());
            if (key && value) {
                styleObject[key] = value;
            }
        });

        return styleObject;
    };

    static setAvatar(avatar: any) {
        console.log(avatar);
        var authToken = JSON.parse(window.sessionStorage.getItem('loggedUserRight') as string);
        authToken.avatar = avatar?.avatar;
        authToken.avatarTh = avatar?.avatarTh;
        window.sessionStorage.setItem('loggedUserRight', JSON.stringify(authToken));


        var authToken_InUser = JSON.parse(window.sessionStorage.getItem('loggedInUser') as string);
        authToken_InUser.avatar = avatar?.avatar;
        authToken_InUser.avatarTh = avatar?.avatarTh;
        window.sessionStorage.setItem('loggedInUser', JSON.stringify(authToken_InUser));
    }

    static setDisplayName(firstName: string, lastName: string) {
        var authTokenn = JSON.parse(window.sessionStorage.getItem('loggedUserRight') as string);
        authTokenn.firstName = firstName;
        authTokenn.lastName = lastName;
        window.sessionStorage.setItem('loggedUserRight', JSON.stringify(authTokenn));
    }

    static async downloadFile(fileURL: string, filename: string) {

        fetch('https://cors-anywhere.herokuapp.com/' + fileURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/pdf',
            },
        })
            .then((response) => response.blob())
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    `FileName.pdf`,
                );

                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                // Clean up and remove the link
                //link.parentNode.removeChild(link);
            });
    }

    static relativeDataRemapping(data: any, dataHeaders: any) {
        var sep_array = [];
        var mix_array = [];
        var subCounter = 0;
        var setTo_Data = {};

        var HeaderName: any[] = [];
        var row_data: { [s: string]: any; } = [];
        var in_data: any[] = [];

        Object.entries(dataHeaders).forEach(([key, value]: any) => { HeaderName.push(value.replace(/ /g, '')) });
        Object.entries(data).forEach(([key, value]) => { row_data.push(value) });


        for (var i = 0; i < row_data.length; i++) {

            Object.entries(row_data[i]).forEach(([key, value]) => { in_data.push(value) });
        }

        for (var count = 0; count < in_data.length; count++) {

            setTo_Data = Object.assign({ [HeaderName[subCounter]]: in_data[count] });
            subCounter++;

            if (subCounter === HeaderName.length) {
                subCounter = 0;
            }
            sep_array.push(setTo_Data);
        }

        for (var D_length = 0; D_length < sep_array.length; D_length++) {
            let array_Temp = {};

            for (var H_length = 0; H_length < HeaderName.length; H_length++) {
                Object.assign(array_Temp, sep_array[D_length + H_length]);
            }

            mix_array.push(array_Temp);
            D_length += HeaderName.length - 1;
        }

        return mix_array;
    };


    static objectreMap = (mapReturn: any) => {
        var tempmapReturn: any[] = [];
        Object.entries(mapReturn).forEach(([key, value]) => { tempmapReturn.push(value) });
        return tempmapReturn;
    }

    static buildQueryString(params: any, preserveParams: boolean, allowEmpty: boolean) {
        const queryParams: string[] = [];

        for (const k in params) {
            if (params.hasOwnProperty(k) && !CommonUtilities.isNullOrEmpty(params[k])) {
                queryParams.push(
                    preserveParams
                        ? `${k}=${params[k]}`
                        : `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`
                );
            }

            else if (allowEmpty) {
                queryParams.push(`${encodeURIComponent(k)}=`);
            }

        }
        return queryParams.join('&');

    };

    static exportWithToken = async function (this: any, verb: any, url: any, data: any, target: any, filename: any) {

        try {
            let response = await fetch(apiUrlPrefix + url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-AuthToken': this.getAuthToken()
                }
            })

            const blob = await (response).blob();
            console.log(blob)
            if (!response?.ok) {
                throw new Error(`Failed to download file: ${response.status} ${response.statusText}`);
            }

            const objectUrl = URL.createObjectURL(blob);
            //console.log(objectUrl)

            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = objectUrl;
            a.download = filename + '.zip';
            a.click();

            URL.revokeObjectURL(objectUrl);
        } catch (error) {
            console.error('Export failed:', error);
            // Optionally show error to user
        }
    };

    static download = async (urlLink: any, dataSend: any) => {
        let url = 'YOUR_API_ENDPOINT';
        const filename = 'example.zip';
        let data = {};

        url = urlLink;
        data = dataSend;
        // Create a fetch request to download the ZIP file
        fetch(apiUrlPrefix + url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/zip',
                'X-AuthToken': this.getAuthToken()
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.blob();
            })
            .then(blob => {
                // Create a temporary URL for the blob
                const objectUrl = URL.createObjectURL(blob);

                // Create a temporary anchor element to trigger download
                const a = document.createElement('a');
                a.href = objectUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();

                // Clean up
                URL.revokeObjectURL(objectUrl);
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
    };

    static postExport = async (url: any, payload: any, fileName: any) => {
        //console.log( url )
        //console.log( payload )

        try {
            const response = await fetch(apiUrlPrefix + url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-AuthToken': this.getAuthToken() },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                const blob = await response.blob();
                //console.log( blob )

                const url = window.URL.createObjectURL(new Blob([blob]));
                //console.log( url )

                var file_Name = fileName ? fileName + '.zip' : 'Export' + '.zip'
                //console.log( file_Name )

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file_Name);
                document.body.appendChild(link);
                link.click();


            } else {
                console.log('Response body:', await response.text());
                alert('Failed to download file NOT OK');
            }

        } catch (error) {
            console.error('Error downloading file:', error);
            alert('Error downloading file');
        }
    };

    static dateFilter(date: any) {

        if (`${date}`.length === 8) {
            // console.log(format(new Date(`${date}`.substring(4, 6)) , "MMM" ))
            return `${date}`.substring(0, 4) + format(new Date(`${date}`.substring(4, 6)), "MM") + `${date}`.substring(6, 8)

        } else if (`${date}`.length === 19) {
            //  console.log(date);
            return `${date}`.substring(0, 4) + format(new Date(`${date}`.substring(5, 7)), "MM") + `${date}`.substring(8, 10)
        }
    }

    static dateNameFilter(date: any) {

        const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        if (date)
            return monthNames[new Date(date).getMonth()].substring(0, 3) + " " + format(new Date(date), 'd') + ', ' + format(new Date(date), 'yyyy')
    };

    static exportVsWindow(data: any) {
        window.open(apiUrlPrefix + data);
    };


    static async exportVsWindowRespond(data: string) {
        //window.open(apiUrlPrefix + data);

        const newWindow = window.open(apiUrlPrefix + data);
        console.log(newWindow);
        window.addEventListener("message", (event) => {
            console.log("Received response:", event.data);
        });


    };


    static generateChartData(percentageData: any, labels: any, backgroundColor: any, borderColor: any, chartLabel: string, legend: boolean) {
        const options = {
            layout: {
                padding: {
                    top: 0
                }
            },
            plugins: {
                elements: {
                    bar: {
                        borderWidth: 0,
                    },
                }
            }
        };

        const data = {
            labels: labels,
            datasets: [
                {
                    label: chartLabel,
                    data: percentageData,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor[3],
                    borderWidth: 1
                },
            ]
        };

        var chartPassedData = {
            data: data,
            options: options
        }

        return chartPassedData;
    }

    static getdspImages(data: any, value: any) {

        var korrectLogo = 'data:image/png;base64,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'
        var imagePath = '../../assets/images/korrectLogoIcon.png'

        var ClientDSPList = cachingMechanisum.getCachingStorage("ClientDSP");

        // console.log(ClientDSPList)
        //console.log(typeof ClientDSPList)
        //console.log(global.ClientDSP)

        const length_test = ClientDSPList ? Object.keys(ClientDSPList).length : 0

        if (length_test === 0 && global.ClientDSP) {
            ClientDSPList = global.ClientDSP
        }


        var obj = ClientDSPList?.filter((item: any) => {
            return item?.name?.toLocaleLowerCase() === data?.toLocaleLowerCase();
        })[0];

        if (obj && obj.logo) {
            imagePath = "data:image/jpeg;base64," + obj.logo;
        } else {
            imagePath = korrectLogo
        }


        //"E:\DSPLogo.Korrect.png" 
        return imagePath;
    }

    static csvToObjects(csv: string) {


        console.log(csv)

        const rows = csv
            .trim()
            .split("\n")
            .filter(line => line.trim() !== ""); // remove empty lines

        if (rows.length === 0) return [];

        const headers = rows[0]
            .split(",")
            .map(h => h.trim().replace(/^"|"$/g, "")); // remove quotes

        // Parse data rows
        const data = rows.slice(1).map(row => {
            const values = row.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g)?.map(v =>
                v.replace(/^"|"$/g, "").trim()
            ) || [];

            const obj: Record<string, string> = {};
            headers.forEach((key, i) => {
                obj[key] = values[i] || ""; // fill blank if missing
            });
            return obj;
        });

        return data;
    }


    static myArray = [
        "#EF534F", "#C62928", "#980A0B", "#BA69C8",
        "#7B1FA2", "#4A148C",
        "#FFD54F", "#F57C02", "#E65100", "#81C784",
        "#2F7D31", "#1A5E20", "#7FDEEA", "#00838F",
        "#004D41", "#90CAF9", "#029BE5", "#01579B",
        "#DBDBDB", "#000000"
    ];

    static chartColors = [
        '#185a87', '#8fa6ba', '#c77732',
        '#cc4629', '#29cc45', '#2946cc', '#cc2985', '#2985cc', '#8529cc', '#ccac00', '#8acc23', '#6e22b5', '#b8b8c8',
        '#66cc00', '#a65317', '#cc3700', '#cc4f3a', '#33b3b3', '#507ac2', '#cc1075', '#cc7000', '#79c979', '#c2b85a',
        '#9e126b', '#5447a3', '#cc00cc', '#6353c2', '#3a0066', '#4c7f80', '#b29bb2', '#7f2020', '#a9a9a9', '#7a7a7a',
        '#666666', '#660000', '#cccc00', '#006600', '#00cccc', '#0000cc', '#cc00cc', '#cc9aa2', '#ccac00', '#9a9a9a',
        '#c4b28f', '#ccb78f', '#6e3710', '#1f3434', '#56701c', '#cc4f3a', '#cccaa3', '#9a9552', '#000066', '#006f6f',
        '#917000', '#7a7a7a', '#004d00', '#660000', '#a64a4a', '#a3122e', '#c27d4c', '#7aa82a', '#198f8f', '#967373',
        '#660066', '#445522', '#cc3700', '#63c900', '#a8956b', '#79c979', '#cccaa3', '#56701c', '#660066', '#cc4f85',
        '#9e126b', '#b3cccc', '#0099cc', '#345bb3', '#176bb3', '#8aa8b3', '#8aaac2', '#5f95b3', '#5f9cc2', '#00cccc',
        '#009ea3', '#33b3b3', '#3aa3a3', '#789fb5', '#8193a3', '#4c7f80', '#c26868', '#c2b85a', '#bfb873', '#9a9552',
        '#c27d4c', '#ccae7a', '#a65317', '#c27f00', '#cccbbf', '#8aa8b3', '#6e3710', '#1f6b45', '#7f2020', '#a9a9a9'
    ];

    static dspColor = [
        { dspName: "Youtube", colour: "#fe0808" },
        { dspName: "Spotify", colour: "#25d865" },
        { dspName: "Apple", colour: "#f21147" },
        { dspName: "Apple Music", colour: "#5DC4F9" },
        { dspName: "Soundtrack Your Brand colour", colour: "#f23a46" },
        { dspName: "Sound track Your Brand colour", colour: "#f23a46" },
        { dspName: "Tidal", colour: "#152dff" },
        { dspName: "7Digital", colour: "#ff6f00" },
        { dspName: "Amazon", colour: "#FF9900" },
        { dspName: "CapCut", colour: "#4ECDC4" },
        { dspName: "iTunes", colour: "#d36fe9" },
        { dspName: "Soundcloud", colour: "#FF5500" },
        { dspName: "Deezer", colour: "#a53eff" },
        { dspName: "Snap", colour: "#fffc00" },
        { dspName: "qobuz", colour: "#16878f" },
        { dspName: "redeye distribution", colour: "#f04734" },
        { dspName: "ADRev", colour: "#63255e" },
        { dspName: "Pias", colour: "#ff776c" }
    ]


    static tipaltiScopes = [
        { selection: true, value: 'tipalti.api.payee.read' },
        { selection: true, value: 'tipalti.api.payee.write' },
        { selection: true, value: 'tipalti.api.payer-entity.read' },
        { selection: true, value: 'tipalti.api.report1099.write' },
        { selection: true, value: 'tipalti.api.report1099.read' },
        { selection: true, value: 'tipalti.api.report1042.write' },
        { selection: true, value: 'tipalti.api.report1042.read' },
        { selection: true, value: 'tipalti.api.payment-batch.write' },
        { selection: true, value: 'tipalti.api.payment-batch.read' },
        { selection: true, value: 'tipalti.api.payment.read' },
        { selection: true, value: 'tipalti.api.gl-account.read' },
        { selection: true, value: 'tipalti.api.tax-code.read' },
        { selection: true, value: 'tipalti.api.invoice.read' },
        { selection: true, value: 'tipalti.api.custom-field.read' },
        { selection: true, value: 'tipalti.api.invoice-batch.read' },
        { selection: true, value: 'tipalti.api.invoice-batch.write' }
    ];

    static currencySymbols = [
        { "currency": "EUR", "symbols": "€" },
        { "currency": "AED", "symbols": "د.إ" },
        { "currency": "AFN", "symbols": "؋" },
        { "currency": "XCD", "symbols": "$" },
        { "currency": "ALL", "symbols": "L" },
        { "currency": "AMD", "symbols": "֏" },
        { "currency": "ANG", "symbols": "ƒ" },
        { "currency": "AOA", "symbols": "Kz" },
        { "currency": "ARS", "symbols": "$" },
        { "currency": "USD", "symbols": "$" },
        { "currency": "AUD", "symbols": "A$" },
        { "currency": "AWG", "symbols": "ƒ" },
        { "currency": "AZN", "symbols": "₼" },
        { "currency": "BAM", "symbols": "KM" },
        { "currency": "BBD", "symbols": "$" },
        { "currency": "BDT", "symbols": "৳" },
        { "currency": "BGN", "symbols": "лв" },
        { "currency": "BHD", "symbols": "د.ب" },
        { "currency": "BIF", "symbols": "Fr" },
        { "currency": "BMD", "symbols": "$" },
        { "currency": "BND", "symbols": "$" },
        { "currency": "BOB", "symbols": "Bs" },
        { "currency": "BRL", "symbols": "R$" },
        { "currency": "BSD", "symbols": "$" },
        { "currency": "BTN", "symbols": "Nu" },
        { "currency": "NOK", "symbols": "kr" },
        { "currency": "BWP", "symbols": "P" },
        { "currency": "BYR", "symbols": "Br" },
        { "currency": "BZD", "symbols": "$" },
        { "currency": "CAD", "symbols": "$" },
        { "currency": "CDF", "symbols": "Fr" },
        { "currency": "CHF", "symbols": "CHF" },
        { "currency": "CNY", "symbols": "¥" },
        { "currency": "COP", "symbols": "$" },
        { "currency": "HRK", "symbols": "kn" },
        { "currency": "CSD", "symbols": "din" },
        { "currency": "CRC", "symbols": "₡" },
        { "currency": "CUP", "symbols": "₱" },
        { "currency": "CVE", "symbols": "$" },
        { "currency": "DKK", "symbols": "kr" },
        { "currency": "DOP", "symbols": "$" },
        { "currency": "DZD", "symbols": "دج" },
        { "currency": "EGP", "symbols": "ج.م" },
        { "currency": "MAD", "symbols": "د.م." },
        { "currency": "ERN", "symbols": "Nfk" },
        { "currency": "ETB", "symbols": "ታብ" },
        { "currency": "FJD", "symbols": "$" },
        { "currency": "FKP", "symbols": "£" },
        { "currency": "GEL", "symbols": "₾" },
        { "currency": "GHC", "symbols": "₵" },
        { "currency": "GIP", "symbols": "£" },
        { "currency": "GMD", "symbols": "D" },
        { "currency": "GNF", "symbols": "Fr" },
        { "currency": "GBP", "symbols": "£" },
        { "currency": "GTQ", "symbols": "Q" },
        { "currency": "GYD", "symbols": "$" },
        { "currency": "HKD", "symbols": "HK$" }
    ]

    static defaultListOfClient = [
        'BellPartners_Korr', 'BellDistro_Korr', 'BELLSEK_Korr', 'BellGroup_Korr', 'CherryRed_Korr',
        'Ninja_Korr', 'Silva_Korr', 'LNE_Korr', 'Splice_Korr', 'ArtistServe_Korr',
        'QaNew_korr', 'StagingNew_Korr', 'UFO_Korr', 'Ultra_Korr', 'GoldenChild_Korr'
    ];

    static getCSymbols(value: any) {
        const currencyList = CommonUtilities?.currencySymbols?.find((dsp: any) => dsp.currency?.toLowerCase().includes(value?.toLowerCase()));
        return currencyList ? currencyList.symbols : value;
    }

    static headerName(value: any) {
        return value?.replace(/\b\w/g, function (char: any) {
            return char?.toUpperCase();
        });
    }

    static getDSPColor(value: any) {
        const dspColor = CommonUtilities?.lookUpTypeList('subProvider', value, 'bgColor');
        const dsp = CommonUtilities?.dspColor?.find((dsp: any) => dsp.dspName?.toLowerCase().includes(value?.toLowerCase()));

        //console.log(value + " dspColor " + dspColor + " dspColour " + dsp?.colour)

        const returnColor = dspColor ? dspColor : dsp?.colour ? dsp.colour : "#212121";
        //console.log(returnColor)
        return returnColor;
    }

    static isNullOrEmpty(value: string) {
        return value === undefined || value === null || value === '';
    }
}